import React from 'react'
import { FieldErrors } from 'react-hook-form'
import get from 'lodash/get'
import { ControlledHiddenInput } from 'transfix-form/components'
import ControlledTextField from 'transfix-form/components/ControlledTextInput'
import { TAs2ConnectionConfigModalSchema } from '../schema/AS2ConnectionConfigModalSchema'
import { useAs2ConnectionConfigModalFormContext } from './useAs2ConnectionConfigModalForm'

const getErrorMessage = <T extends FieldErrors<TAs2ConnectionConfigModalSchema>, K extends keyof T>(
  errors: T,
  keyName: K
): string | undefined => {
  return get(errors, [keyName, 'message'])
}

export const As2ConnectionConfigModalForm = () => {
  const { control, errors } = useAs2ConnectionConfigModalFormContext()

  return (
    <form data-test='As2ConnectionConfigModalForm'>
      <ControlledHiddenInput name='id' control={control} />
      <ControlledTextField
        name='identifier'
        control={control}
        TextInputProps={{
          label: 'Identifier',
          required: true,
          validationMessage: getErrorMessage(errors, 'identifier'),
          error: !!getErrorMessage(errors, 'identifier'),
          placeholder: 'Enter the identifier',
          dataTest: 'input-identifier',
        }}
      />
      <ControlledTextField
        name='outboundUrl'
        control={control}
        TextInputProps={{
          label: 'Outbound URL',
          required: true,
          validationMessage: getErrorMessage(errors, 'outboundUrl'),
          error: !!getErrorMessage(errors, 'outboundUrl'),
          placeholder: 'Enter the outbound URL',
          dataTest: 'input-outbound-url',
        }}
      />
      <ControlledTextField
        name='serverInfoCredentialsIdentifier'
        control={control}
        TextInputProps={{
          label: 'Server Info Credentials Identifier',
          required: true,
          validationMessage: getErrorMessage(errors, 'serverInfoCredentialsIdentifier'),
          error: !!getErrorMessage(errors, 'serverInfoCredentialsIdentifier'),
          placeholder: 'Enter the path of the secrets manager location of the credentials',
          dataTest: 'input-credentials-identifier',
        }}
      />
      <ControlledTextField
        name='transfixIdentifier'
        control={control}
        TextInputProps={{
          label: 'Transfix Identifier',
          required: true,
          validationMessage: getErrorMessage(errors, 'transfixIdentifier'),
          error: !!getErrorMessage(errors, 'transfixIdentifier'),
          placeholder: 'Enter the identifier to use for our AS2 Server',
          dataTest: 'input-transfix-identifier',
        }}
      />
    </form>
  )
}
